export default __webpack_public_path__ + "static/blob-29-96ffa431ebcb8e23cb2cc235d7c4e825.svg";